<template>
  <div>
    <el-card shadow="always">
      <div class="side-frame">
        <span style="font-size: 14px; color: #606266">包车应收账单基本信息</span>
      </div>
      <edit-form
        ref="editForm"
        :custStatementCode="params.custStatementCode"
        :disabled="isDisableEditForm"
        :isDisableParentCust="isDisableParentCust"
        :params="params"
        @codeChange="onCodeChange"
      />
      <el-divider></el-divider>
      <div class="side-frame">
        <span style="font-size: 14px; color: #606266">包车应收账单明细</span>
      </div>
      <charters-table :code="params.custStatementCode" ref="contactTable" />
      <el-divider></el-divider>
      <div class="side-frame">
        <span style="font-size: 14px; color: #606266">包车应收账单订单明细</span>
      </div>
      <detail-all-table :code="params.custStatementCode" ref="detailAllTable" />
    </el-card>
  </div>
</template>
<script>
import ChartersTable from './charters-table/index'
import DetailAllTable from './detail-all-table/index'
import EditForm from './edit-form/index'

export default {
  name: 'finance-charteredReceivable-detail',
  components: {
    EditForm,
    ChartersTable,
    DetailAllTable,
  },
  data() {
    return {
      code: '',
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    // 是否禁用表单
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
    // 是否禁用主客户
    isDisableParentCust() {
      return this.pageType === 'edit'
    },
  },
  mounted() {
    this.code = this.params.custStatementCode
  },
  methods: {
    onCodeChange(val) {
      this.code = val
    },
  },
}
</script>

